import React from 'react';
import { UI_TEXT } from '../utils/constants';

const TTL_MS = 60 * 24 * 60 * 60 * 1000;

function daysRemaining(addedAt) {
  return Math.ceil((addedAt + TTL_MS - Date.now()) / (24 * 60 * 60 * 1000));
}

// Filled bookmark SVG
const BookmarkFilled = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    aria-hidden="true"
  >
    <path d="M5 3a2 2 0 0 0-2 2v16l9-4 9 4V5a2 2 0 0 0-2-2H5z" />
  </svg>
);

const ReadingListPanel = ({ items, onRemove, onClear, onClose, isDrawer }) => {
  return (
    <div className={isDrawer ? 'w-full h-full flex flex-col' : 'w-72 flex-shrink-0'}>
      <div
        className={
          isDrawer
            ? 'flex flex-col h-full overflow-hidden bg-white border-l border-gray-200'
            : 'rounded-2xl overflow-hidden sticky top-6 border border-gray-100 bg-white'
        }
        style={isDrawer ? undefined : { boxShadow: '0 20px 40px rgba(83, 97, 94, 0.10)' }}
      >
        {/* Header */}
        <div className="flex items-center gap-2 px-4 py-3 border-b border-gray-100">
          <BookmarkFilled className="h-4 w-4 text-amber-500 flex-shrink-0" />
          <span className="text-sm font-bold text-gray-800 font-manrope flex-1">
            {UI_TEXT.myList}
          </span>
          <span className="bg-amber-100 text-amber-700 text-xs font-bold px-2 py-0.5 rounded-full">
            {items.length}
          </span>
          <button
            onClick={onClear}
            className="text-xs text-gray-400 hover:text-red-400 transition-colors ml-1"
            aria-label={UI_TEXT.clearList}
          >
            {UI_TEXT.clearList}
          </button>
          {onClose && (
            <button
              onClick={onClose}
              className="ml-1 text-gray-400 hover:text-gray-600 transition-colors"
              aria-label="Закрити"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          )}
        </div>

        {/* Items */}
        <ul className={`divide-y divide-gray-50 overflow-y-auto ${isDrawer ? 'flex-1' : 'max-h-[60vh]'}`}>
          {items.map(({ bookId, title, author, addedAt }) => {
            const days = daysRemaining(addedAt);
            return (
              <li key={bookId} className="flex items-start gap-2 px-4 py-3 group">
                <BookmarkFilled className="h-3.5 w-3.5 text-amber-400 flex-shrink-0 mt-0.5" />
                <div className="flex-1 min-w-0">
                  <p className="text-xs font-semibold text-gray-800 truncate leading-snug">
                    {title}
                  </p>
                  <p className="text-xs italic text-gray-500 truncate leading-snug">
                    {author}
                  </p>
                  <p className="text-xs text-gray-400 mt-0.5">
                    {UI_TEXT.daysLeft} {days} {UI_TEXT.days}
                  </p>
                </div>
                <button
                  onClick={() => onRemove(bookId)}
                  className="flex-shrink-0 text-gray-300 hover:text-red-400 transition-colors text-base leading-none mt-0.5"
                  aria-label={`${UI_TEXT.clearList} — ${title}`}
                >
                  ×
                </button>
              </li>
            );
          })}
        </ul>

        {/* Footer note */}
        <div className="px-4 py-3 bg-amber-50 border-t border-amber-100">
          <p className="text-xs text-amber-700 leading-snug">
            {UI_TEXT.readingListNote}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ReadingListPanel;
